// 拿到封装好的网络请求工具包
import request from '../utils/request'
// 专家接口
export const expertImg = params => request({
  url: '/api/expert/images/next',
  params,
  headers: { 'Token-Circus': window.localStorage.getItem('Token-Circus') }
})

export const expertImg2 = params => request({
  url: '/api/expert/images/previous',
  params,
  headers: { 'Token-Circus': window.localStorage.getItem('Token-Circus') }
})
//异常专区获取图片
export const getAnomalousImages = params => request({
  url: '/api/pic/getMerger',
  params,
  headers: { 'Token-Circus': window.localStorage.getItem('Token-Circus') }
})

//异常专区提交
export const subAnomalousImages = data => request({
  url: '/api/expert/info2',
  method: 'post',
  data,
  headers: { 'Token-Circus': window.localStorage.getItem('Token-Circus') }
})